import { useUIStore } from '../store';
import { ListView } from '../views/ListView';
import { WeekView } from '../views/WeekView';
import { MonthView } from '../views/MonthView';
import { MindMapView } from '../views/MindMapView';
import { ProjectView } from '../views/ProjectView';
import { StatsView } from '../views/StatsView';
import { TaskModal } from '../components/TaskModal';
import { ProjectModal } from '../components/ProjectModal';

export function Dashboard() {
  const { currentView, isTaskModalOpen, isProjectModalOpen } = useUIStore();

  const renderView = () => {
    switch (currentView) {
      case 'list':
        return <ListView />;
      case 'week':
        return <WeekView />;
      case 'month':
        return <MonthView />;
      case 'mindmap':
        return <MindMapView />;
      case 'project':
        return <ProjectView />;
      case 'stats':
        return <StatsView />;
      default:
        return <ListView />;
    }
  };

  return (
    <div className="h-full">
      {renderView()}
      
      {/* 模态框 */}
      {isTaskModalOpen && <TaskModal />}
      {isProjectModalOpen && <ProjectModal />}
    </div>
  );
}
